import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { REELS_SUBNAV } from "./types";

export function PrivateReelsSubnav() {
  return (
    <nav
      className="flex gap-1 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-thin"
      aria-label="Secciones de Reels privados"
    >
      {REELS_SUBNAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              "shrink-0 rounded-xl border px-3 py-2 text-left transition",
              isActive
                ? "border-violet-500/40 bg-violet-500/15 text-white"
                : "border-white/[0.06] bg-white/[0.02] text-muted-foreground hover:border-white/15 hover:text-white/90",
            )
          }
        >
          <div className="text-xs font-semibold leading-none">{item.label}</div>
          <div className="mt-1 text-[10px] opacity-70 leading-none">
            {item.description}
          </div>
        </NavLink>
      ))}
    </nav>
  );
}
